export default (state = [], action) => {
  switch (action.type) {
    case 'REQUEST_COMMISSIONS':
      return {
        ...state,
        failureFetching: false,
        isFetching: true,
      };
    case 'RECEIVE_COMMISSIONS':
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        tresholds: action.recievedData,
      };
    case 'FAILURE_COMMISSIONS':
      return {
        ...state,
        failureFetching: true,
        isFetching: false,
      };
    default:
      return state;
  }
};
